import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

import { environment } from '../../environments/environment';
import { environment as qa } from '../../environments/environment.qa';
import { environment as dev } from '../../environments/environment.dev';
import { environment as stage } from '../../environments/environment.stage';
import { environment as prd } from '../../environments/environment.prod';
import { Subject } from 'rxjs';

@Injectable()
export class AppService {

  //-- VARIABLES -------------------------------------------------------|

  readonly ENV: any;
  readonly PID: any = "";

  //-- CONSTRUCTOR -----------------------------------------------------|

  constructor() {
    var env: string = <any> window[<any>'env'];
    switch (env) {
      case 'dev': this.ENV = dev; break;
      case 'stg': this.ENV = stage; break;
      case 'qa': this.ENV = qa; break;
      case 'prd': this.ENV = prd; break;
      default: this.ENV = environment; break;
    }

    this.PID = (window as any)["pid"]
  }
  
  //-- LOADING STATUS --------------------------------------------------|

  private loadingStatus: boolean = true;
  private _loadingStatus = new Subject<boolean>();
  $loadingStatus = this._loadingStatus.asObservable();

  getLoadingStatus() { return this.loadingStatus; }

  setLoadingStatus(val: boolean) {
    this.loadingStatus = val;
    this._loadingStatus.next(val);
  }

  //-- TERMS STATUS --------------------------------------------------|

  private termsStatus: boolean = false;
  private _termsStatus = new Subject<boolean>();
  $termsStatus = this._termsStatus.asObservable();

  getTermsStatus() { return this.termsStatus; }

  changeTermsVisibility() {
   var status = !this.termsStatus;
   this.termsStatus = status;
    this._termsStatus.next(status);
  }

  //-- ROUTING ---------------------------------------------------------|
  
  addClickEvent(){
    setTimeout(() => {    document.querySelectorAll('a[href^="#"]').forEach(function(anchor, index) {
      anchor.addEventListener('click', function(event) {
        event.preventDefault();
        
        const href = anchor.getAttribute('href');
        const targetId = href ? href.substring(1) : ''; 
        const anchorId = targetId + "ref" + index;
        anchor.id = anchorId;
        const targetElement = document.getElementById(targetId);
  
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
          // Create the "Return to reference" link
          const r2rLink = document.getElementById(targetId+ 'r2r')
          if(!r2rLink){
            const returnLink = document.createElement('a');
            returnLink.href = `#${anchorId}`;
            returnLink.id = targetId + 'r2r';
            returnLink.textContent = 'Return to reference';
            returnLink.style.display = 'block';
            returnLink.style.width = 'fit-content';
            var targetStyle = window.getComputedStyle(targetElement); 
            returnLink.style.fontSize = targetStyle.fontSize;
            returnLink.style.color = targetStyle.color;
            returnLink.style.fontWeight = targetStyle.fontWeight;
            returnLink.setAttribute('aria-describedby', targetId);
  
            // Insert the link underneath the target element
            targetElement.insertAdjacentElement('afterend', returnLink);
  
            //add similar click event to return to linking element
            returnLink.addEventListener('click', function(event) {
              event.preventDefault();
              const returnElement = document.getElementById(anchor.id);
              if (returnElement) {
                returnElement.scrollIntoView({ behavior: 'smooth' });
                returnElement.focus();
                returnLink.remove();
              }
            })
          
          // Focus on the created return link
          returnLink.focus();
          }else {
            r2rLink.focus();
          }
        }
      });
    });}, 0)

  }

  //--------------------------------------------------------------------|

}
